export const AccessTokenKey = 'token'
export const AccessTokenExpirationKey = 'tokenExpires'
export const RefreshTokenKey = 'refreshToken'
export const InitialQuizAnswersKey = 'initialQuizAnswers'
export const EmailForSignInKey = 'emailForSignIn'
